var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanFeature6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87992",
    "data-name": "Group 87992",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.136,
    height: 24.69,
    viewBox: "0 0 26.136 24.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25579",
    "data-name": "Rectangle 25579",
    width: 26.136,
    height: 24.69,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87991",
    "data-name": "Group 87991",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308288",
    "data-name": "Path 308288",
    d: "M8.789,3.654H5.106a1.23,1.23,0,0,0-1.2.952L3.586,5.993a.9.9,0,0,0-.423-.026,1.147,1.147,0,0,0-.816,1.391,1.252,1.252,0,0,0,.821,1L2.378,11.4l.381,1.223h3.43l.446-3a2.152,2.152,0,0,0,2.154-2.15Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308289",
    "data-name": "Path 308289",
    d: "M7.672,3.654V8.03A2.143,2.143,0,0,1,7,9.591a2.152,2.152,0,0,0,1.79-2.119V3.654Z",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308290",
    "data-name": "Path 308290",
    d: "M9.191,24.411H1.626V17.675L.932,15.22A6.026,6.026,0,0,1,2.32,11.374l.01,0a4.774,4.774,0,0,0,4.085,0,9.98,9.98,0,0,1,2.778,6.933l0,.615Z",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308291",
    "data-name": "Path 308291",
    d: "M2.048,15.22a6.028,6.028,0,0,1,1.146-3.532,4.728,4.728,0,0,1-.865-.31l-.01,0A6.026,6.026,0,0,0,.931,15.22l.694,2.455v6.736H2.742V17.675Z",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308292",
    "data-name": "Path 308292",
    d: "M11.918,9.164l0-.048-.018,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308293",
    "data-name": "Path 308293",
    d: "M23.061,5.258l-1.487.194a2.712,2.712,0,0,1-.742-.005l-2.775-.405a2.71,2.71,0,0,0-1.778.353L12.941,7.387a2.2,2.2,0,0,0-1.019,1.729l3.665.943a1.014,1.014,0,0,0,.5,1.965l.393-.1a19.015,19.015,0,0,1,2.531-.446A7.137,7.137,0,0,0,22.644,10.1a2.759,2.759,0,0,1,.549-.319l.971-.419Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308294",
    "data-name": "Path 308294",
    d: "M12.941,8.5l3.338-1.992a2.71,2.71,0,0,1,1.778-.353l2.775.405a2.752,2.752,0,0,0,.742,0l1.487-.194.834,3.1.268-.116-1.1-4.1-1.487.194a2.712,2.712,0,0,1-.742-.005l-2.776-.405a2.7,2.7,0,0,0-1.777.354L12.941,7.387a2.2,2.2,0,0,0-1.019,1.725l.368.025a2.019,2.019,0,0,1,.651-.633",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308295",
    "data-name": "Path 308295",
    d: "M22.226,10.027a.363.363,0,1,1-.363.363.364.364,0,0,1,.363-.363",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308296",
    "data-name": "Path 308296",
    d: "M17.749,9.5l-2.162.56a1.014,1.014,0,0,0,.506,1.964l.392-.1a18.929,18.929,0,0,1,2.534-.447",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25577",
    "data-name": "Rectangle 25577",
    width: 8.369,
    height: 7.787,
    transform: "translate(7.348 14.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25578",
    "data-name": "Rectangle 25578",
    width: 1.117,
    height: 7.787,
    transform: "translate(7.348 14.512)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308297",
    "data-name": "Path 308297",
    d: "M3.333,17.122V15.248H.931v2.5A1.768,1.768,0,0,0,2.7,19.515H9.34a1.2,1.2,0,0,0,0-2.393Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308298",
    "data-name": "Path 308298",
    d: "M2.048,17.746v-2.5H.931v2.5A1.768,1.768,0,0,0,2.7,19.515H3.814a1.768,1.768,0,0,1-1.766-1.769",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11049",
    "data-name": "Line 11049",
    x1: 0.542,
    transform: "translate(6.094 9.622)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308299",
    "data-name": "Path 308299",
    d: "M19.247,18.835l1.866,2.437a.529.529,0,0,0,.836,0l1.867-2.437a.512.512,0,0,0-.419-.82h-.578v-3.8H20.244v3.8h-.579A.512.512,0,0,0,19.247,18.835Z",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308300",
    "data-name": "Path 308300",
    d: "M21.082,18.015v-3.8h-.838v3.8h-.578a.512.512,0,0,0-.419.82l1.866,2.437a.53.53,0,0,0,.837,0c.034-.046.071-.094.109-.143L20.314,18.85a.838.838,0,0,0,.768-.835",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308301",
    "data-name": "Path 308301",
    d: "M22.4,17.03a.42.42,0,0,0,.419-.419v-.837a.419.419,0,1,0-.838,0v.837a.419.419,0,0,0,.419.419",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11050",
    "data-name": "Line 11050",
    x2: 25.576,
    transform: "translate(0.279 24.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308302",
    "data-name": "Path 308302",
    d: "M20.91,21.466,19.025,19a.8.8,0,0,1,.64-1.268h.3V14.217a.28.28,0,0,1,.28-.279h2.574a.279.279,0,0,1,.279.279v3.519h.3A.8.8,0,0,1,24.037,19l-1.885,2.462A.782.782,0,0,1,20.91,21.466Zm-1.245-3.172a.23.23,0,0,0-.2.371L21.335,21.1a.251.251,0,0,0,.392,0l1.867-2.438a.23.23,0,0,0-.2-.37h-.579a.279.279,0,0,1-.279-.279V14.5H20.523v3.519a.279.279,0,0,1-.279.279Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308303",
    "data-name": "Path 308303",
    d: "M25.855,24.132H9.47V22.578h6.247A.279.279,0,0,0,16,22.3V14.512a.279.279,0,0,0-.279-.279H15.08a3.563,3.563,0,0,0,.965-1.914c.081-.01.423-.1.508-.122a18.607,18.607,0,0,1,2.489-.44,7.015,7.015,0,0,0,2.049-.478.279.279,0,0,0-.2-.52A6.489,6.489,0,0,1,19,11.2a19.12,19.12,0,0,0-2.578.454c-.486.186-1.117.178-1.283-.42a.736.736,0,0,1,.523-.9l2.162-.56a.28.28,0,0,0-.141-.541l-2.161.56-.007,0a3.551,3.551,0,0,0-3-1.6,1.754,1.754,0,0,1,.572-.562l3.338-1.992a2.435,2.435,0,0,1,1.594-.317l2.776.405a4.4,4.4,0,0,0,1.3-.057L23.2,9.742a.825.825,0,0,0,1,.579l1.321-.35a.824.824,0,0,0,.582-1.008L24.949,4.714a.824.824,0,0,0-1-.578l-1.32.349a.819.819,0,0,0-.594.627,4.077,4.077,0,0,1-1.16.059L18.1,4.766a3,3,0,0,0-1.961.39L12.8,7.148a2.378,2.378,0,0,0-.954,1.117c-.063.014-.126.028-.188.045a3.555,3.555,0,0,0-1.574,5.923H8.641a10.263,10.263,0,0,0-1.964-2.988l.2-1.355a2.434,2.434,0,0,0,2.19-2.418V3.681A2.314,2.314,0,0,0,10.29,1.323C10.209.739,10.1.24,10.1.219A.281.281,0,0,0,9.671.045a5.771,5.771,0,0,1-3.45.486,6.918,6.918,0,0,0-3.7.662A5.423,5.423,0,0,0,0,6.076C-.021,7.86.44,9.912,2.37,10.323l-.215.827a.242.242,0,0,0-.05.046A6.316,6.316,0,0,0,.653,15.191h0c0,.018-.006,2.555-.006,2.555A2.046,2.046,0,0,0,1.364,19.3H1.346v4.835H.279a.279.279,0,0,0,0,.558H25.855a.279.279,0,1,0,0-.558ZM11.92,10.281l-.088-.33a.251.251,0,1,1,.485-.13l.086.318.358-.1a.251.251,0,0,1,.13.485l-.7.189a.422.422,0,0,0,.218.816l.208-.056a.924.924,0,0,1,.614,1.737l.088.33a.252.252,0,1,1-.486.13l-.085-.318-.358.1a.252.252,0,0,1-.13-.486l.7-.189a.422.422,0,0,0-.218-.815l-.208.056a.923.923,0,0,1-1.13-.654A.924.924,0,0,1,11.92,10.281ZM2.738,6.592a.659.659,0,0,1,.768-.331.28.28,0,0,0,.352-.2L4.179,4.67a.947.947,0,0,1,.927-.736h3.4V7.472A1.875,1.875,0,0,1,6.636,9.344H6.094a.279.279,0,1,0,0,.558h.218l-.193,1.3a4.471,4.471,0,0,1-3.41.038L3.4,8.58a1.406,1.406,0,0,0,.632-.452A.279.279,0,1,0,3.579,7.8a.889.889,0,0,1-.4.266.992.992,0,0,1-.553-.756,1.058,1.058,0,0,1,.116-.719M2.4,11.717a5.036,5.036,0,0,0,3.945-.007A9.685,9.685,0,0,1,8.03,14.233H7.348a.279.279,0,0,0-.279.279v2.331H3.613V13.864a.28.28,0,1,0-.559,0v1.1H1.217A5.765,5.765,0,0,1,2.4,11.717M1.211,17.746V15.528H3.054v1.594a.279.279,0,0,0,.279.279H9.341a.918.918,0,0,1,0,1.835H2.7A1.491,1.491,0,0,1,1.211,17.746Zm7.7,6.386H1.9v-4.5a2.035,2.035,0,0,0,.793.16H7.069v2.5a.279.279,0,0,0,.279.279H8.912ZM7.627,22.02V19.794H9.341a1.476,1.476,0,0,0,0-2.951H7.627V14.792h7.811V22.02Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanFeature6);
export default __webpack_public_path__ + "static/media/Plan_Feature_6.961922998908a3c070fb9f3b660de9d0.svg";
export { ForwardRef as ReactComponent };